<template>
  <motlet-neo :options="motletOptions">
    <template #content>
      <v-row class="h-100">
        <v-col>
          <v-row class="h-100">
            <v-col class="col-20">
              <v-card class="card-wrap">
                <v-card-title>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <span v-on="on" class="ellipsis">{{ $t('ov.sys.title.abap.dump') }}</span>
                    </template>
                    <span>{{ $t('ov.sys.title.abap.dump') }}</span>
                  </v-tooltip>
                </v-card-title>
                <v-card-text class="data-area text-h6" @contextmenu="onContextmenuAbapDump">
                  {{ values.cntAbapDump }}
                </v-card-text>
              </v-card>
            </v-col>
            <v-col class="col-20">
              <v-card class="card-wrap">
                <v-card-title>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <span v-on="on" class="ellipsis">{{ $t('ov.sys.title.enqueue.lock') }}</span>
                    </template>
                    <span>{{ $t('ov.sys.title.enqueue.lock') }}</span>
                  </v-tooltip>
                </v-card-title>
                <v-card-text class="data-area text-h6" @contextmenu="onContextmenuEnqueueLock">
                  {{ values.cntEnqueueLock }}
                </v-card-text>
              </v-card>
            </v-col>
            <v-col class="col-20">
              <v-card class="card-wrap">
                <v-card-title>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <span v-on="on" class="ellipsis">{{ $t('ov.sys.title.exclusive.lock') }}</span>
                    </template>
                    <span>{{ $t('ov.sys.title.exclusive.lock') }}</span>
                  </v-tooltip>
                </v-card-title>
                <v-card-text class="data-area text-h6" @contextmenu="onContextmenuExclusiveLock">
                  {{ values.cntExclusiveLock }}
                </v-card-text>
              </v-card>
            </v-col>
            <v-col class="col-20">
              <v-card class="card-wrap">
                <v-card-title>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <span v-on="on" class="ellipsis">{{ $t('ov.sys.title.upd.record.error.abbr') }}</span>
                    </template>
                    <span>{{ $t('ov.sys.title.upd.record') }}</span>
                  </v-tooltip>
                </v-card-title>
                <v-card-text class="data-area text-h6" @contextmenu="onContextmenuUpdateRecord">
                  {{ values.cntUpdateRecord }}
                </v-card-text>
              </v-card>
            </v-col>
            <v-col class="col-20">
              <v-card class="card-wrap">
                <v-card-title>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <span v-on="on" class="ellipsis">{{ $t('ov.sys.title.logon.dup.abbr') }}</span>
                    </template>
                    <span>{{ $t('ov.sys.title.logon.dup') }}</span>
                  </v-tooltip>
                </v-card-title>
                <v-card-text class="data-area text-h6" @contextmenu="onContextmenuLogonDuplication">
                  {{ values.cntLogonDup }}
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </template>
    <template #menu>
      <contextmenu :options="contextmenuParam"></contextmenu>
    </template>
  </motlet-neo>
</template>

<script>
import { mapState } from 'vuex';
import { api } from '@/api/common/instances';
import bus from '@/utils/bus';
import instanceable from '@/views/overview/system/abap/mixins/instanceable';
import contextmenuable from '@/views/overview/system/abap/mixins/contextmenuable';

export default {
  mixins: [instanceable, contextmenuable],
  data() {
    return {
      motletOptions: {
        id: 'overview/system/abap/SystemSummary',
        title: 'ov.sys.title.sstm.sum',
        gearMenu: {
          use: true,
        },
        abapDumpTerm: {
          use: true,
          value: 600,
          divider: false,
        },
        updRecTerm: {
          use: true,
          value: 600,
          divider: true,
        },
      },
      messages: [
        {
          name: 'cntAbapDump',
          fields: ['cnt'],
        },
        {
          name: 'cntEnqueueLock',
          fields: ['cnt'],
        },
        {
          name: 'cntExclusiveLock',
          fields: ['cnt'],
        },
        {
          name: 'cntUpdateRecord',
          fields: ['canceledCnt'],
        },
        {
          name: 'cntLogonDup',
          fields: ['cnt'],
        },
      ],
      values: {
        cntAbapDump: null,
        cntEnqueueLock: null,
        cntExclusiveLock: null,
        cntUpdateRecord: null,
        cntLogonDup: null,
      },
      abapDumpData: {
        lastTime: new Date().getTime(),
        buffer: [],
      },
      updRecData: {
        lastTime: new Date().getTime(),
        buffer: [],
      },
      contextmenuUrl: '',
    };
  },
  computed: {
    ...mapState('common/user', ['username']),
  },
  watch: {
    instances: {
      handler: 'changeInstancesHandler',
    },
  },
  methods: {
    wsDataHandler(key, response, ctime) {
      if (key.name === 'cntAbapDump') {
        if (ctime >= this.abapDumpData.lastTime) {
          this.abapDumpData.lastTime = Number(ctime);
          this.abapDumpData.buffer.shift();
          // eslint-disable-next-line prettier/prettier
          this.abapDumpData.buffer.push(response.reduce((acc, rspn) => { return acc += parseInt(rspn.cnt); }, 0));
        }
        // eslint-disable-next-line prettier/prettier
        this.values[key.name] = this.abapDumpData.buffer.reduce((acc, elm) => { return acc += elm; }, 0);
      } else if (key.name === 'cntUpdateRecord') {
        if (ctime >= this.updRecData.lastTime) {
          this.updRecData.lastTime = Number(ctime);
          this.updRecData.buffer.shift();
          // eslint-disable-next-line prettier/prettier
          this.updRecData.buffer.push(response.reduce((acc, rspn) => { return acc += parseInt(rspn.canceledCnt); }, 0));
        }
        // eslint-disable-next-line prettier/prettier
        this.values[key.name] = this.updRecData.buffer.reduce((acc, elm) => { return acc += elm; }, 0);
      } else {
        this.values[key.name] = 0;
        // eslint-disable-next-line prettier/prettier
        this.values[key.name] = response.reduce((acc, rspn) => { return acc += parseInt(rspn.cnt); }, 0);
      }
      // FINISH::Modified.by.KWShin.2024.01.30.
    },
    sendMessage() {
      const requests = this.messages.map(message => ({
        key: { name: message.name, sstmId: this.instances[0].systemId },
        fields: message.fields,
        handler: {
          every: this.wsDataHandler,
        },
      }));
      this.$websocket.realtime.send({ requests });
    },
    async changeInstancesHandler() {
      await this.getAbapDumpTerm();
      await this.getUpdRecTerm();
      await this.getAbapDumpDataBuffer();
      await this.getUpdRecDataBuffer();
      this.sendMessage();
    },
    onContextmenuAbapDump(event) {
      this.contextmenuUrl = '/views/detailview/abap/dump';
      this.onContextmenuChart(event);
    },
    onContextmenuEnqueueLock(event) {
      this.contextmenuUrl = '/views/detailview/abap/ci';
      this.onContextmenuChart(event);
    },
    onContextmenuExclusiveLock(event) {
      this.contextmenuUrl = '/views/detailview/abap/ci';
      this.onContextmenuChart(event);
    },
    onContextmenuUpdateRecord(event) {
      this.contextmenuUrl = '/views/detailview/abap/ci';
      this.onContextmenuChart(event);
    },
    onContextmenuLogonDuplication(event) {
      this.contextmenuUrl = '/views/detailview/abap/user';
      const actives = this.instances.filter(d => d.active);
      const selectedDescendant = actives.length > 1 ? {} : actives[0];
      this.onContextmenuChart(event, selectedDescendant);
    },
    async getAbapDumpTerm() {
      let rspn;
      ({
        data: { motletProperties: rspn },
      } = await api.get(`/prefer/users/${this.username}/motlet-properties`, { params: { motletId: `${this.motletOptions.id}/abapDumpTerm` } }));
      if (rspn) this.motletOptions.abapDumpTerm.value = parseInt(rspn);
    },
    async getUpdRecTerm() {
      let rspn;
      ({
        data: { motletProperties: rspn },
      } = await api.get(`/prefer/users/${this.username}/motlet-properties`, { params: { motletId: `${this.motletOptions.id}/updRecTerm` } }));
      if (rspn) this.motletOptions.updRecTerm.value = parseInt(rspn);
    },
    async getAbapDumpDataBuffer() {
      let endDateTime = this.abapDumpData.lastTime;
      let beginDateTime = this.abapDumpData.lastTime - this.motletOptions.abapDumpTerm.value * 1000;
      ({ data: this.abapDumpData.buffer } = await api.get('/motlet-data/abap-dump-buffer-data', {
        params: {
          sstmId: this.system.id,
          beginYmdhms: beginDateTime,
          endYmdhms: endDateTime,
        },
      }));
    },
    async getUpdRecDataBuffer() {
      let endDateTime = this.updRecData.lastTime;
      let beginDateTime = this.updRecData.lastTime - this.motletOptions.updRecTerm.value * 1000;
      ({ data: this.updRecData.buffer } = await api.get('/motlet-data/upd-rec-buffer-data', {
        params: {
          sstmId: this.system.id,
          beginYmdhms: beginDateTime,
          endYmdhms: endDateTime,
        },
      }));
    },
  },
  created() {
    /*
      Commmented.by.KWShin.2023.01.12.
      Motlet에 포함된 GearMenu에서 TaskType/LoadKind에 변동이 생기면
      Bus에서 신호가 온다.
      필터링 조건 반영을 위해 allDay를 호출하여 차트를 갱신한다.
    */
    bus.$on(`update:abapDumpTerm-${this.motletOptions.id}`, abapDump => {
      this.motletOptions.abapDumpTerm.value = abapDump;
    });
    bus.$on(`update:updRecTerm-${this.motletOptions.id}`, updRec => {
      this.motletOptions.updRecTerm.value = updRec;
    });
  },
  destroyed() {
    bus.$off(`update:abapDumpTerm-${this.motletOptions.id}`);
    bus.$off(`update:updRecTerm-${this.motletOptions.id}`);
  },
};
</script>

<style scoped>
.ellipsis {
  text-overflow: ellipsis;
  white-space: nowrap;
  word-wrap: normal;
  width: 100%;
  height: 16px;
  overflow: hidden;
}
.col-20 {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 20%;
  flex: 0 0 20%;
  max-width: 20%;
}
.data-area {
  height: calc(100% - 37px);
  display: flex;
  justify-content: center;
  align-items: center;
}
div.v-card__title {
  padding: 8px 12px 6px 12px;
  text-align: center;
}
</style>
